module.exports = __webpack_public_path__ + "static/media/handyman.fe516cda.png";